import type { FC, ReactNode } from 'react'
import type { StageMode } from '@/types'

import { cn } from '@/lib/utils'
import { STAGE_MODES } from '@/constants/stage'

interface StageModeToggleProps {
    mode: StageMode
    onModeChange: (mode: StageMode) => void
    className?: string
}

const StageModeToggle: FC<StageModeToggleProps> = ({ mode, onModeChange, className }): ReactNode => {
    return (
        <div
            role='group'
            aria-label='בחירת מסכה'
            className={cn('inline-flex items-center gap-1 rounded-full border border-border bg-background/70 p-1 shadow-xl shadow-black/30 backdrop-blur-md', className)}
        >
            {STAGE_MODES.map((option) => {
                const active = mode === option.value

                return (
                    <button
                        key={option.value}
                        type='button'
                        aria-pressed={active}
                        onClick={() => onModeChange(option.value)}
                        className={cn(
                            'min-h-10 rounded-full px-4 text-sm font-medium transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                            active ? 'bg-primary text-primary-foreground' : 'text-foreground/75 hover:text-foreground'
                        )}
                    >
                        {option.label}
                    </button>
                )
            })}
        </div>
    )
}

export default StageModeToggle
